import { ArrowLeft } from 'lucide-react';

export default function TermsPage({ onBack }) {
  return (
    <div data-testid="terms-page" className="min-h-screen px-5 py-6 max-w-lg mx-auto">
      {onBack && (
        <button data-testid="terms-back" onClick={onBack}
          className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center mb-6 hover:bg-gray-200 transition-colors">
          <ArrowLeft size={18} className="text-gray-600" />
        </button>
      )}
      <h1 className="text-2xl font-extrabold text-gray-900 mb-6">Terms & Conditions</h1>

      <div className="prose prose-sm text-gray-600 space-y-4">
        <p className="text-xs text-gray-400">Last updated: March 2026</p>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">1. Acceptance of Terms</h2>
          <p className="text-sm leading-relaxed">By accessing or using WTFHappened ("the Service"), you agree to be bound by these Terms & Conditions. If you do not agree, do not use the Service.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">2. Service Description</h2>
          <p className="text-sm leading-relaxed">WTFHappened is an AI-powered news explanation platform that provides simplified explanations of trending topics. The Service includes a free trial period followed by a paid subscription.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">3. Free Trial & Subscription</h2>
          <p className="text-sm leading-relaxed">New users receive a 2-day free trial. After the trial period, a paid subscription of £3.99/month + VAT is required to continue accessing the Service. Subscriptions auto-renew unless cancelled. You may cancel at any time through your account settings.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">4. User Accounts</h2>
          <p className="text-sm leading-relaxed">You are responsible for maintaining the confidentiality of your account credentials. You must provide accurate information during registration. We reserve the right to suspend or terminate accounts that violate these terms.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">5. Content & AI Explanations</h2>
          <p className="text-sm leading-relaxed">Explanations are generated by AI and are for informational purposes only. They should not be considered financial, legal, or professional advice. We do not guarantee the accuracy, completeness, or timeliness of any explanation.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">6. Privacy</h2>
          <p className="text-sm leading-relaxed">We collect and process your data in accordance with our Privacy Policy. By using the Service, you consent to data collection including your preferences, usage patterns, and account information.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">7. Limitation of Liability</h2>
          <p className="text-sm leading-relaxed">The Service is provided "as is" without warranties of any kind. WTFHappened shall not be liable for any damages arising from the use or inability to use the Service.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">8. Changes to Terms</h2>
          <p className="text-sm leading-relaxed">We reserve the right to modify these terms at any time. Continued use of the Service after changes constitutes acceptance of the updated terms.</p>
        </section>

        <section>
          <h2 className="text-sm font-bold text-gray-900 mt-4 mb-2">9. Contact</h2>
          <p className="text-sm leading-relaxed">For questions about these Terms, contact us at support@wtfhappened.app.</p>
        </section>
      </div>
    </div>
  );
}
